export default __webpack_public_path__ + "static/media/all-the-little-lights.7387314d.jpg";